import { application } from "./application"

import DpagreementController from "./dpagreement_controller"
application.register("dpagreement", DpagreementController)

import FormValidatorController from "./form_validator_controller"
application.register("form-validator", FormValidatorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SyncController from "./sync_controller"
application.register("sync", SyncController)

import SyncProgressController from "./sync_progress_controller"
application.register("sync-progress", SyncProgressController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import CaptchaPowController from "./captcha_pow_controller"
application.register("captcha-pow", CaptchaPowController)

import CollapseIconController from "./collapse_icon_controller"
application.register("collapse-icon", CollapseIconController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CsvExportController from "./csv_export_controller"
application.register("csv-export", CsvExportController)

import SourceTargetFilterController from "./source_target_filter_controller"
application.register("source-target-filter", SourceTargetFilterController)

import WebauthnController from "./webauthn_controller"
application.register("webauthn", WebauthnController)
